import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";

const Koszonolevel = () => {
  return (
    <Box bg="gray.50" py={{ base: 12, md: 20 }}>
      <Container maxW="4xl">
        <Box
          bg="white"
          px={{ base: 6, md: 12 }}
          py={{ base: 10, md: 14 }}
          borderRadius="2xl"
          boxShadow="lg"
          border="1px solid"
          borderColor="gray.100"
        >
          <VStack spacing={6} align="stretch" fontFamily="'Great Vibes', cursive">
            <Heading
              as="h2"
              textAlign="center"
              fontFamily="'Great Vibes', cursive"
              fontSize={{ base: "4xl", md: "6xl" }}
              color="blue.900"
              fontWeight="400"
            >
              Tisztelt Hozzátartozók!
            </Heading>

            <Text fontSize={{ base: "lg", md: "3xl" }} lineHeight="1.9" color="gray.700">
              Ezúton szeretnénk őszinte hálánkat és köszönetünket kifejezni
              Önöknek azért a bizalomért, amellyel intézményünket megtisztelték,
              amikor szerettüket ránk bízták.
            </Text>

            <Text fontSize={{ base: "lg", md: "3xl" }} lineHeight="1.9" color="gray.700">
              Számunkra ez a bizalom nemcsak felelősséget, hanem egyben
              megtisztelő feladatot is jelent. Az idősek otthonában élő lakók
              nem csupán ellátottak számunkra – idővel közösségünk részévé,
              „hozzánk tartozóvá” válnak.
            </Text>

            <Text fontSize={{ base: "lg", md: "3xl" }} lineHeight="1.9" color="gray.700">
              Mindennapi munkánk során arra törekszünk, hogy biztonságot,
              odafigyelést, méltóságot és szeretetteljes légkört biztosítsunk
              számukra.
            </Text>

            <Text fontSize={{ base: "lg", md: "3xl" }} lineHeight="1.9" color="gray.700">
              Tudjuk, hogy egy ilyen döntés sokszor nehéz, és érzelmileg
              megterhelő lehet a családtagok számára. Éppen ezért különösen
              fontos számunkra, hogy Önök érezzék: szerettük jó kezekben van,
              és mi mindent megteszünk azért, hogy testi és lelki jóllétét
              egyaránt biztosítsuk.
            </Text>

            <Text fontSize={{ base: "lg", md: "3xl" }} lineHeight="1.9" color="gray.700">
              Köszönjük, hogy bizalmukkal megtiszteltek bennünket, és hogy
              lehetőséget adtak arra, hogy részesei lehessünk szerettük
              mindennapjainak.
            </Text>

            <Box pt={4}>
              <Text fontSize={{ base: "xl", md: "3xl" }} fontWeight="600" color="blue.900">
                Tisztelettel és megbecsüléssel:
              </Text>
              <Text fontSize={{ base: "xl", md: "3xl" }} mt={2} color="gray.700">
                Az intézmény vezetése és dolgozói
              </Text>
            </Box>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Koszonolevel;